// extracted by mini-css-extract-plugin
export var aboveInput = "_lw-0";
export var actionButton = "_lw-5";
export var actionButtonContainer = "_lw-1";
export var actionIcon = "_lw-6";
export var aiInfoContainer = "_lw-2";
export var attachmentWrapper = "_lw-7";
export var bold = "_lw-3";
export var checkIcon = "_lw-8";
export var clickingRecipientBar = "_lw-11";
export var commentThreadSwitch = "_lw-a";
export var draftImage = "_lw-b";
export var draftImageContainer = "_lw-c";
export var draftImages = "_lw-e";
export var editButton = "_lw-g";
export var editor = "_lw-f";
export var editorContainer = "_lw-y";
export var editorErrorTooltipWrapper = "_lw-9";
export var headerDivider = "_lw-h";
export var icon = "_lw-i";
export var info = "_lw-j";
export var internal = "_lw-n";
export var internalDivider = "_lw-k";
export var internalMessage = "_lw-l";
export var messageInputCard = "_lw-m";
export var messageInputForm = "_lw-o";
export var messageInputFormInternal = "_lw-p";
export var options = "_lw-q";
export var publicMessageCustomer = "_lw-s";
export var publicMessageMerchant = "_lw-r";
export var removeImageButton = "_lw-d";
export var replyButtons = "_lw-t";
export var showSignatureButton = "_lw-u";
export var spinner = "_lw-v";
export var verticalButtonDivider = "_lw-4";
export var visibilitySelector = "_lw-w";
export var warning = "_lw-x";
export var wrappingText = "_lw-z";
export var writingInternalNoteTopBorder = "_lw-10";